interface Bounds {
  longitude_left: number;
  latitude_top: number;
  longitude_right: number;
  latitude_bottom: number;
}

import * as mapboxgl from 'mapbox-gl';

export default function fitBounds(map: mapboxgl.Map, bounds: Bounds, maxZoom = 14) {
  map.fitBounds(
    new mapboxgl.LngLatBounds(
      new mapboxgl.LngLat(bounds.longitude_left, bounds.latitude_top),
      new mapboxgl.LngLat(bounds.longitude_right, bounds.latitude_bottom),
    ),
    {
      padding: 30,
      maxZoom: maxZoom,
    },
  );
}
